








































































import Vue, { PropType } from "vue";
import { HealthPocMetric, HealthPocViewModel } from "@/utils/healthPocViewAdapter";
import HealthMetricCard from "./HealthMetricCard.vue";
import HealthWorkoutCard from "./HealthWorkoutCard.vue";
import { emptyMetric, formatDuration, metricByKey, recentWorkouts } from "../healthPagePresentation";

export default Vue.extend({
  name: "HealthActivitiesPanel",
  components: { HealthMetricCard, HealthWorkoutCard },
  props: {
    view: { type: Object as PropType<HealthPocViewModel>, required: true },
    hasSummary: { type: Boolean, default: false }
  },
  computed: {
    recentWorkouts() {
      return recentWorkouts(this.view);
    },
    workoutCountMetric(): HealthPocMetric {
      return {
        key: "workouts",
        label: "Treinos",
        value: this.recentWorkouts.length,
        unit: null,
        available: this.hasSummary,
        measuredAt: null
      };
    },
    activeMinutesMetric(): HealthPocMetric {
      return metricByKey(this.view, "activeMinutes") || emptyMetric("activeMinutes", "Tempo ativo", "min");
    }
  },
  methods: { formatDuration }
});
